<template>
  <header>
    <ul><!--
      --><router-link to="/#concept" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">Concept</a></li>
      </router-link><!--
      --><router-link to="/nos-scenarios-escape-caen" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">Nos énigmes</a></li>
      </router-link><!--
      --><router-link to="/#nestor-bomb-simulator" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">NESTOR</a></li>
      </router-link><!--
      --><router-link to="/#infos-pratiques" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">Infos pratiques</a></li>
      </router-link><!--
      --><router-link to="/entreprises" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">Entreprises</a></li>
      </router-link><!--
      --><router-link to="/nos-scenarios-escape-caen#bons-cadeaux" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">Bons cadeaux</a></li>
      </router-link><!--
      --><router-link to="/contact#faq" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">f.a.q.</a></li>
      </router-link><!--
      --><router-link to="/contact" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">Contact</a></li>
      </router-link><!--
      --><router-link to="/#tarifs" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">Tarifs</a></li>
      </router-link><!--
      --><router-link to="/nos-scenarios-escape-caen" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li v-bind:class="[ isExactActive && 'active' ]" class="headerMenu_reserver"><a v-bind:href="href">Réserver</a></li>
      </router-link><!--
    --></ul>
  </header>
</template>

<script>
export default {
  name: "HeaderMenu_Site"
}
</script>
